module.exports = __webpack_public_path__ + "img/nps-image.86400f1f.jpg";